module.exports = __webpack_public_path__ + "img/svg/result-loser-background-overlay.0fcec65710dd44b584859605a21f2757.svg";